mainApp.component('timeZonePicker', {
    templateUrl: '/public/components/time-zone-picker.component.html',
    bindings: {
    },
    controller: TimeZonePickerController,
});


function TimeZonePickerController($scope, $state, TimeZoneService, DateRangeService) {
    var ctrl = this;
    ctrl.selectedTimeZone = TimeZoneService.getCurrentTimeZone();

    TimeZoneService.getTimeZones(function(timeZones) {
        ctrl.timeZones = timeZones;
    });

    /*
        When selected timezone is changed, we want to stay on the selected date range but in a new timezone.
        So we convert current start and end timestamps to a new timezone and zoom to there.
    */
    $scope.$watch('$ctrl.selectedTimeZone', function(newVal, oldVal) {
        if(newVal != oldVal) {
            TimeZoneService.setCurrentTimeZone(newVal);
            var start = $state.params.start || DateRangeService.getCopyOfCurrentDateRange().from.getTime();
            var end = $state.params.end || DateRangeService.getCopyOfCurrentDateRange().to.getTime();
            start = TimeZoneService.convertFromTo(Number(start), oldVal, newVal);
            end = TimeZoneService.convertFromTo(Number(end), oldVal, newVal);
            DateRangeService.zoomTo(start, end, null, true);
        }
    });

}